<template>
	<div class="log-property-form row q-pa-xs q-col-gutter-sm">
		<div class="col-12 col-sm-6">
			<species-selector
					v-model="editedLogProps.species"
					:preselected-species="editedLogProps.species"
					@input="$emit('update', editedLogProps)"
					:error="errors.species"
					:error-message="$t('error.logProps.species')"
					emit dense
			/>
		</div>
		<div class="col-12 col-sm-6">
			<q-input v-model="editedLogProps.name" :label="$t('logNo')" @input="$emit('update', editedLogProps)"
					 :error="errors.name"
					 :error-message="$t('error.logProps.name')"
			/>
		</div>
		<div class="col-12 col-sm-6">
			<q-input v-model="editedLogProps.customerQualityName" :label="$t('quality')" @input="$emit('update', editedLogProps)"/>
		</div>
		<div class="col-12 col-sm-6">
			<q-input v-model="editedLogProps.structure" :label="$t('structure')" @input="$emit('update', editedLogProps)"/>
		</div>
		<div class="col-12 col-sm-6">
			<q-input v-model="editedLogProps.characteristic" :label="$t('characteristic')" @input="$emit('update', editedLogProps)"/>
		</div>
		<div class="col-12 col-sm-6">
			<q-input v-model="editedLogProps.grade" :label="$t('grade')" @input="$emit('update', editedLogProps)"/>
		</div>
		<div class="col-12 col-sm-6">
			<q-input v-model="editedLogProps.place" :label="$t('place')" @input="$emit('update', editedLogProps)"/>
		</div>
		<div class="col-12 col-sm-6">
			<q-input v-model="editedLogProps.thicknessMm" :label="$t('thickness')" @input="$emit('update', editedLogProps)"/>
		</div>
		<div class="col-12 col-sm-6">
			<q-input v-model="editedLogProps.internalQualityName" :label="$t('internalQuality')" @input="$emit('update', editedLogProps)"/>
		</div>
		<div class="col-12 col-sm-6">
			<q-input v-model="editedLogProps.logInfo" :label="$t('logInfo')" @input="$emit('update', editedLogProps)"/>
		</div>

		<div class="q-mt-md" style="max-width: 600px;" v-if="showSubmit">
			<q-btn @click="$emit('close')" :label="$t('button.cancel')" flat/>
			<q-btn @click="$emit('update-log')" :label="$t('button.create')" :loading="loading" color="primary"/>
		</div>
	</div>
</template>

<script>
	import SpeciesSelector from "@/components/main/SpeciesSelector";

	export default {
		name: "LogPropertyForm",
		components: {SpeciesSelector},
		props: {
			log: Object,
			showSubmit: {
				type: Boolean,
				default: false
			},
			errors: {
				type: Object,
				default: () => ({})
			},
			loading: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				editedLogProps: {}
			}
		},
		mounted() {
			this.editedLogProps = {...this.log};
		},
	}
</script>

<style lang="scss" scoped>
	.log-property-form {
		max-width: 600px;
	}
</style>